import { createTheme, Theme as MaterialTheme } from '@mui/material/styles'

import { Theme } from './ThemeType'

const createMaterialUiTheme = (theme: Theme): MaterialTheme => {
    const { color } = theme

    return createTheme({
        palette: {
            primary: {
                light: color.p500,
                main: color.p500,
                dark: color.p500,
                contrastText: color.white,
            },
            error: {
                light: color.e600,
                main: color.e600,
                dark: color.e600,
                contrastText: color.e600,
            },
            background: {
                default: color.g100,
            },
        },
        typography: {
            fontFamily: ['"Poppins"', '"Inter"', 'sans-serif'].join(','),
        },
        spacing: 5,
    })
}

export { createMaterialUiTheme }
